// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-container {
  background: var(--white);
  padding: 16px 24px;
}
.language-container .card-languages {
  background: rgba(255, 255, 255, 0.59);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(9.7px);
  border: 1px solid rgba(179, 179, 179, 0.3);
  padding: 10px 20px 30px 0 !important;
  margin-top: 20px;
}
.language-container .card-languages .row .card-box {
  display: flex;
}
.language-container .card-languages .row .card-box .icons-box {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-top: 20px;
}
.language-container .card-languages .row .card-box .icons-box .button .icon {
  font-size: 14px;
}
.language-container .card-languages .row .card-box .icons-box .active-lang {
  background: #f6ffed;
}
.language-container .card-languages .row .card-box .icons-box .active-lang .active-lang-check {
  color: #5ca138;
}
.language-container .card-languages .row .card-box .icons-box .active-lang:hover {
  border-color: #5ca138;
}
.language-container .card-languages .row .card-box .icons-box .inactive-lang {
  background: #fff2f0;
}
.language-container .card-languages .row .card-box .icons-box .inactive-lang .active-lang-close {
  color: #ff6163;
}
.language-container .card-languages .row .card-box .image-box {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
}
.language-container .card-languages .row .card-box .image-box .img-fluid {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(50px);
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
@media (max-width: 768px) {
  .language-container .card-languages .row .card-box .image-box .img-fluid {
    width: 60px;
    height: 60px;
  }
}
.language-container .card-languages .row .card-box .text-line {
  margin-left: 10px;
}
.language-container .card-languages .row .card-box .text-line .card-body {
  padding: 20px 0 0 0;
}
.language-container .card-languages .row .card-box .text-line .card-body .card-title {
  font-size: 18px;
  font-weight: bold;
  color: var(--dark);
}
.language-container .card-languages .row .card-box .text-line .card-body .card-text {
  font-size: 14px;
  color: var(--dark);
}

.ant-col-spin {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/page/language.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,kBAAA;AACF;AACE;EACE,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,4BAAA;EACA,0CAAA;EACA,oCAAA;EACA,gBAAA;AACJ;AAEM;EACE,aAAA;AAAR;AAEQ;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AAAV;AAGY;EACE,eAAA;AADd;AAKU;EACE,mBAAA;AAHZ;AAKY;EACE,cAAA;AAHd;AAMY;EACE,qBAAA;AAJd;AAQU;EACE,mBAAA;AANZ;AAQY;EACE,cAAA;AANd;AAWQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AATV;AAWU;EACE,uCAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AATZ;AAUY;EANF;IAOI,WAAA;IACA,YAAA;EAPZ;AACF;AAWQ;EACE,iBAAA;AATV;AAWU;EACE,mBAAA;AATZ;AAWY;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AATd;AAYY;EACE,eAAA;EACA,kBAAA;AAVd;;AAmBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAhBF","sourcesContent":[".language-container {\n  background: var(--white);\n  padding: 16px 24px;\n\n  .card-languages {\n    background: rgba(255, 255, 255, 0.59);\n    border-radius: 16px;\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(9.7px);\n    border: 1px solid rgba(179, 179, 179, .3);\n    padding: 10px 20px 30px 0 !important;\n    margin-top: 20px;\n\n    .row {\n      .card-box {\n        display: flex;\n\n        .icons-box {\n          display: flex;\n          flex-wrap: wrap;\n          flex-direction: column;\n          margin-top: 20px;\n\n          .button {\n            .icon {\n              font-size: 14px;\n            }\n          }\n\n          .active-lang {\n            background: #f6ffed;\n\n            .active-lang-check {\n              color: #5ca138;\n            }\n\n            &:hover {\n              border-color: #5ca138;\n            }\n          }\n\n          .inactive-lang {\n            background: #fff2f0;\n\n            .active-lang-close {\n              color: #ff6163;\n            }\n          }\n        }\n\n        .image-box {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          background: transparent;\n\n          .img-fluid {\n            box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);\n            backdrop-filter: blur(50px);\n            width: 80px;\n            height: 80px;\n            border-radius: 50%;\n            @media (max-width: 768px) {\n              width: 60px;\n              height: 60px;\n            }\n          }\n        }\n\n        .text-line {\n          margin-left: 10px;\n\n          .card-body {\n            padding: 20px 0 0 0;\n\n            .card-title {\n              font-size: 18px;\n              font-weight: bold;\n              color: var(--dark);\n            }\n\n            .card-text {\n              font-size: 14px;\n              color: var(--dark);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.ant-col-spin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
